import Timetable from 'common/components/Timetable';

export default function TimetableMenu({ updateSize }) {
  return <Timetable updateSize={updateSize} />;
}
